import type { MailboxInfo } from "owa-client-types";
import { copilotSettingsStore } from "owa-copilot-settings-store";
import { isAccountFeatureEnabled } from "owa-feature-flags";

export function isFrontierPrivateStagingUserEnabled(mailboxInfo: MailboxInfo): boolean {
    if (isAccountFeatureEnabled("mon-copilot-dev-frontier", mailboxInfo)) {
        return true;
    }
    
    const store = copilotSettingsStore(mailboxInfo);
    return (store.isFrontierStagingUser &&
        isAccountFeatureEnabled("mon-copilot-draft-frontier-private-staging", mailboxInfo));
}
